import { Predicate } from "@siteimprove/alfa-predicate";
import { Role } from "../../role.js";
const { equals, property } = Predicate;
export function hasImplicitRole(nameOrPredicate, ...names) {
    let predicate;
    if (typeof nameOrPredicate === "function") {
        predicate = nameOrPredicate;
    }
    else {
        predicate = property("name", equals(nameOrPredicate, ...names));
    }
    return (element) => Role.fromImplicit(element).some(predicate);
}
//# sourceMappingURL=has-implicit-role.js.map